export default {
	contactgroup: 'group',
	signupform: 'form',
	task: 'task',
	phonenumbers: 'phone number',
	'account/preference': 'account preferences',
	customform: 'custom form',
	twilionumber: 'phone number',
}
